// extracted by mini-css-extract-plugin
export default {"overlay":"offboarding-page-overlay_overlay__lMpGr","dialog":"offboarding-page-overlay_dialog__Njt5Y"};